const API_SERVER_HOST = process.env.NODE_ENV === 'production' ? 'https://api.mart.harucode.com' : 'http://localhost:8081';
// const API_SERVER_HOST = 'https://api.mart.harucode.com';
const config = {
  API_SERVER_HOST
}

export default config;
